/**
 * 排出ユーザー招待
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/emissions`

 const invitation_user = {
  namespaced: true,
  state: {},
  actions: {
    create ({ commit }, { emission_id, params }) {
      const api_path = `${API_PATH}/${emission_id}/invitation_users`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
 }
 export default invitation_user